import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterFacetsCarouselComponent } from './filter-facets-carousel.component';
import { MmChipModule, MmIconModule, } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersModule } from '~app/modules/filters/filters.module';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [
    FilterFacetsCarouselComponent,
  ],
  imports: [
    CommonModule,
    MmChipModule,
    QaLocatorsModule,
    TranslateModule,
    FiltersModule,
    MmIconModule,
    CarouselModule
  ],
  exports: [
    FilterFacetsCarouselComponent
  ]
})
export class FilterFacetsCarouselModule {
}
